import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useInteractiveSlug from './useInteractiveSlug';

const useDateHistory = (currentData) => {
  const navigate = useNavigate();
  const { url } = useInteractiveSlug();

  useEffect(() => {
    navigate(
      `${url}/${currentData.currentYear.title}/${currentData.currentMonth.title.toLowerCase()}`,
    );
  }, [currentData, navigate]);
};

export default useDateHistory;
